import { useAppStateContext } from '@/shared';
import { defaultLoggerApi } from '../apis';
import * as Sentry from '@sentry/react';
import { version } from '../../../../package.json';

export const useLogger = () => {
  const { appState } = useAppStateContext();
  const deviceInfo = appState.deviceInfo;

  const LogError = (type, errorInfo) => {
    try {
      const deviceLog = deviceInfo
        ? `Version : ${version} |Store : ${deviceInfo.branchId} | Device :${deviceInfo.deviceId} | Group : ${deviceInfo.groupId} | Info : `
        : '';

      const logInfo = deviceLog.concat(errorInfo);
      defaultLoggerApi({ type, logInfo });
    } catch (error) {
      console.error(error);
    }
  };

  const LogInformation = (info) => {
    Sentry.captureMessage(info, 'info');
  };

  const LogToExternal = (type, data) => {
    switch (type) {
      case 'error': {
        Sentry.captureException(data);
        break;
      }
      case 'info':
        LogInformation(data);
        break;
      default:
        console.error('Invalid type');
        break;
    }
  };
  return { LogError, LogInformation, LogToExternal };
};
